import io from 'socket.io-client';

// Conexiones en vivo (Socket.IO). El servidor decide quién eres con el token de la sesión: ya no basta con decirle un id.
// El token va como función, así que se vuelve a leer en CADA conexión y una reconexión usa el token renovado en silencio.

const urlApi = () => process.env.REACT_APP_API_URL || 'http://localhost:5001';

const leerToken = (clave) => {
  try { return localStorage.getItem(clave); } catch { return null; }
};

const conectar = (clave) => {
  const socket = io(urlApi(), {
    transports: ['websocket', 'polling'],
    reconnection: true,
    auth: (entregar) => entregar({ token: leerToken(clave) }),
  });
  // El servidor corta la conexión cuando la sesión caduca. Socket.IO no reconecta solo en ese caso: si ya hay un token
  // vigente (renovado) se vuelve a conectar; si no, el servidor lo rechaza y la conexión se queda cerrada.
  socket.on('disconnect', (motivo) => {
    if (motivo === 'io server disconnect') socket.connect();
  });
  return socket;
};

// Clientes y proveedores (token `token`)
export const conectarSocketUsuario = () => conectar('token');

// Panel de superadmin (token `adminToken`)
export const conectarSocketAdmin = () => conectar('adminToken');
